export default __webpack_public_path__ + "static/media/truffle.d1b539c6.png";